<template>
    <modal ref="prompt">
        <form @submit.prevent="save">
            <div class="modal-body">
                <div class="mb-3">
                    <label class="form-label">Name</label>
                    <input type="text" required class="form-control" v-model="name" />
                </div>
                <div class="mb-0">
                    <label class="form-label">Text</label>
                    <textarea rows="15" required class="form-control" v-model="text" />
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" type="submit">{{item ? 'Edit' : 'Create'}}</button>
            </div>
        </form>
    </modal>
</template>
<script>
import api from "@/common/api";

export default {
    props: [],
    data() {
        return {
            callback: null,
            loading: false,
            name: "",
            text: "",
            item: null
        };
    },
    created() {
    },
    methods: {
        save() {
            if (this.loading) {
                return;
            }

            let method = api.knowledgeCreate;
            if (this.item && this.item.id) {
                method = api.knowledgeUpdate;
            }

            this.loading = true;
            method({ id: this.item ? this.item.id : 0, name: this.name, text: this.text }).then((item) => {
                this.item = item;
                this.flashSuccess(method === api.knowledgeCreate ? "Knowledge base created" : "Knowledge base updated");
                this.close();
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loading = false;
            });
        },
        open(callback) {
            this.item = null;
            this.name = "";
            this.text = "";
            this.callback = callback;
            this.$refs.prompt.open();
        },
        openEdit(item, callback) {
            this.item = item;
            this.name = item.name;
            this.text = item.text;
            this.callback = callback;
            this.$refs.prompt.open();
        },
        close() {
            if (this.callback && this.item) {
                this.callback(this.item, () => {
                    this.$refs.prompt.close();
                });
            } else {
                this.$refs.prompt.close();
            }
        }
    }
};
</script>
